/*
* PRICING AND CURRENCY RELATED FUNCTIONS
*/
const selectors = [
        '#ProductPrice', '#productPrice', '#ProductPrice-product-template', '#productPrice-product-template',
        '.price', '.product-price', '.product-single__price', '.product__price', '.price-field', '.actual-price', '.add-to-cart__price',
        '.current-price', '.current_price',
        '.product__current-price', // Narrative
        '#ProductPrice-product', '.add-to-cart__price', // Pipeline
        '[data-product-price]', // Slate
        'span[itemprop="price"]'
    ];
const oldPrices = ['compare', 'was', 'original', 'striped', 'old'];

function getCurrencySelectors() {
    let query = [
            '[name="currencies"]',
            '[name="currency-selector"]',
            '[name="doubly-currencies"]'
        ];

    return Array.from(document.querySelectorAll(query));
}

function addCurrencyListener(listenerCallback) {
    if (window.Currency || window.DoublyGlobalCurrency) {
        getCurrencySelectors()
            .forEach(selector => {
                selector.addEventListener('change', listenerCallback)
            });
    }
}

function formatMoney(price) {
    let convertedPrice = parseInt(String(price).replace(/[^0-9]/g, '')) / 100;
    if (!convertedPrice) {
        console.warn('Issue when formatting money. Check formatMoney()', price, convertedPrice);
    }
    return convertedPrice.toFixed(2);
}

function calculatePrice(price) {
    let qty = 1, // We'll default 1 if a quantity modifier isn't found
        calculatedPrice = price * qty;
    if (!calculatedPrice) {
        console.warn('Possible issue with price calculation. Check calculatePrice()', calculatedPrice);
    }
    return calculatedPrice;
}

function convertPrice(currencyConvertObj, price, shopCurrency, newCurrency, format) {
    let cents = 0.0;
    if (format.indexOf('amount_no_decimals') !== -1) {
        cents = currencyConvertObj.convert(parseInt(String(price).replace(/[^0-9]/g, ''), 10) * 100, shopCurrency, newCurrency);
    } else if (shopCurrency === 'JOD' || shopCurrency === 'KWD' || shopCurrency === 'BHD') {
        cents = currencyConvertObj.convert(parseInt(String(price).replace(/[^0-9]/g, ''), 10) / 10, shopCurrency, newCurrency);
    } else { 
        cents = currencyConvertObj.convert(parseInt(String(price).replace(/[^0-9]/g, ''), 10), shopCurrency, newCurrency);
    }
    if (!cents) {
        console.warn('Possible issue with price conversion. Check convertPrice()', cents);
    }
    return cents;
}

function getCurrencyTemplate(currencyConvertObj, currency, format) {
    let template = "${{amount}}";
    
    switch (currencyConvertObj.moneyFormats || currencyConvertObj.money_format || currencyConvertObj.money_with_currency_format) {
        case currencyConvertObj.moneyFormats:
            template = currencyConvertObj.moneyFormats[currency][format];
            break;
        case currencyConvertObj.money_format:
            template = currencyConvertObj.money_format[currency];
            console.warn('Consider updating the currencies JS file', 'https://github.com/carolineschnapp/currencies');
            break;
        case currencyConvertObj.money_with_currency_format:
            template = currencyConvertObj.money_with_currency_format[currency];
            console.warn('Consider updating the currencies JS file', 'https://github.com/carolineschnapp/currencies');
            break;
    }

    if (!template) {
        console.warn('Possible issue with price currency template. Check getCurrencyTemplate()', template);
    }

    return template;
}

function convertAndFormatMoney(currencyConvertObj, product, price) {
    let currency = currencyConvertObj.currentCurrency,
        format = currencyConvertObj.format || '',
        template = getCurrencyTemplate(currencyConvertObj, currency, format),
        convertedPrice = convertPrice(currencyConvertObj, price, product.shop_currency, currency, format);

    if (!convertedPrice) {
        console.warn(`[${product.id}] Possible issue with price format. Check convertAndFormatMoney()`, convertedPrice, currencyConvertObj);
    }

    return currencyConvertObj.formatMoney(convertedPrice, template);
}

function getSelectedPrice(product) {
    let type = product.elements[0].selectedPurchaseType,
        id = product.elements[0].selectedProductSelect.value,
        price = (type === 'autodeliver') ? product.duplicate_to_price[id] : product.variant_to_price[id];

    if (!price) {
        console.warn(`[${product.id}] Possible issue with ${type} price map. Check getSelectedPrice()`, price);
    }

    return calculatePrice(price);
}

function buildFormattedPrice(product, price) {
    if (product.currency_conversion && window.Currency && window.Currency.convert && window.Currency.currentCurrency) {
        return convertAndFormatMoney(window.Currency, product, price);
    } else if (product.currency_conversion && window.DoublyGlobalCurrency && window.DoublyGlobalCurrency.convert && window.DoublyGlobalCurrency.currentCurrency) {
        return convertAndFormatMoney(window.DoublyGlobalCurrency, product, price);
    } else {
        return product.currency_prefix + formatMoney(price) + product.currency_suffix;
    }
}

function getPriceElements(domRoot, optSelector) {
    let prices = domRoot.querySelectorAll(optSelector || selectors);

    if (prices.length === 0) return [];

    return Array.from(prices)
        .filter(price => !['s', 'del', 'strike'].indexOf(price.tagName.toLowerCase()) > -1)
        .filter(price => !oldPrices.some(op => price.className.toLowerCase().includes(op)));
}

export default {
    getCurrencySelectors,
    addCurrencyListener,
    formatMoney,
    calculatePrice,
    getSelectedPrice,
    buildFormattedPrice,
    getPriceElements,
}


// WEBPACK FOOTER //
// ./_static/js/_pricing.js